import { Row } from '@lightningjs/ui-components';
import { getSingleMovie } from '../../../api/movies';
import MovieComponent from '../components/MovieComponent';
import { Storage } from '@lightningjs/sdk';

export default function (page, { movieId }) {
  return getSingleMovie(movieId)
    .then((response) => {
      if (!response || !response.data) {
        console.log('Data not found for movieId:', movieId);
        page._ErrorMessage.visible = true;
        page._Column.items = [];
        page.isUndefined = true;
        // return false; // Return false if data is undefined
      }
      const { data } = response;
      let video = Storage.get('video');
      const movie = data.movie;
      const movieLinks =
        !movie.tvod || (movie.tvod && movie.purchased)
          ? [
              {
                id: 0,
                title: 'Resume',
                image: '/images/movie-info-icons/resume.svg',
                width: 500,
              },
              {
                id: 1,
                title: 'Play from beginning',
                image: '/images/movie-info-icons/play.svg',
                width: 500,
              },
              {
                id: 2,
                title: 'Audio & Subtitles',
                image: '/images/movie-info-icons/subtitles.svg',
                width: 500,
              },
              {
                id: 3,
                title:
                  video?.watchList != 0
                    ? video?.watchList
                      ? 'Added from My List'
                      : 'Add to My List'
                    : movie.on_watchlist
                    ? 'Added from My List'
                    : 'Add to My List',
                image: '/images/movie-info-icons/my-list.svg',
                width: 500,
              },
              {
                id: 4,
                title: '',
                image: '/images/movie-info-icons/thumb-up.svg',
                width: 200,
              },
              {
                id: 5,
                title: '',
                image: '/images/movie-info-icons/thumb-down.svg',
                width: 200,
              },
            ]
          : [
              movie.trailer_hls_stream_url
                ? {
                    id: 1,
                    title: 'Trailer',
                    image: '/images/movie-info-icons/trailer-icon.svg',
                    width: 500,
                  }
                : null,
              movie.tvod_buy
                ? {
                    // Check if movie.tvod_buy is true
                    id: 2,
                    title: `Buy Movie $${movie.tvod_info.tvod_buy_amount}`,
                    image: '/images/movie-info-icons/dollar-sign.png',
                    width: 500,
                  }
                : null, // Include the object if true, or null if false
              movie.tvod_rent
                ? {
                    // Check if movie.tvod_rent is true
                    id: 3,
                    title: `Rent Movie $${movie.tvod_info.tvod_rent_amount}`,
                    image: '/images/movie-info-icons/dollar-sign.png',
                    width: 500,
                  }
                : null, // Include the object if true, or null if false
            ].filter((item) => item !== null); // Remove null elements from the array
      let filteredMovieLinks = movieLinks;
      if (movie.resume_time === null || movie.resume_time === '0') {
        if (!movie.tvod || (movie.tvod && movie.purchased)) {
          filteredMovieLinks = movieLinks.filter((link, index) => index !== 0);
        }
      }

      let items = filteredMovieLinks.map((link, index) => {
        // If link id is 0 and resume_time is null, change the title to 'Play'
        if (link.id === 1 && (movie.resume_time === null || movie.resume_time === '0')) {
          if (!movie.tvod || (movie.tvod && movie.purchased)) {
            link.title = 'Play';
            link.image = '/images/movie-info-icons/resume.svg';
          }
        }
        return {
          w: 210,
          h: 70,
          collision: true,
          index,
          type: MovieComponent,
          movieInfo: movie,
          movieLink: link,
          movieId: movieId,
          id: video.id,
          watchList: video.watchList,
        };
      });
      // Group the last two items into a single row
      const lastIndex = items.length - 1;
      if (!movie.tvod || (movie.tvod && movie.purchased)) {
        items[lastIndex - 1] = {
          type: Row, // Use Row component here
          items: [items[lastIndex - 1], items[lastIndex]],
          collision: true,
        };
        // Remove the last element now that it's in the row
        items = items.slice(0, -1);
      }
      page._ErrorMessage.visible = false;
      page.isUndefined = false;
      page._Column.items = items;
    })
    .catch((error) => {
      console.error('Error fetching movie data:', error);
      /* setTimeout(() => {
        Router.back();
      }, 3000); */
    });
}
